import { Pipe, PipeTransform, inject } from '@angular/core';
import { AccountRole } from '@moxi.gmbh/moxi-typescriptmodels';
import { TranslateService } from '@ngx-translate/core';
import { accountRolesInfo } from '@shared/models';

@Pipe({
  name: 'accountRoleName',
  standalone: true
})
export class AccountRoleNamePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(value: AccountRole): string {
    return this.translateService.instant(
      accountRolesInfo.find(r => r.id === value)?.name
    );
  }
}
